export interface LinkChip {
  label: string
  href: string
}

interface PageLinks {
  top: LinkChip[]
  bottom: LinkChip[]
  exploreMore: LinkChip[]
}

export const PAGE_LINKS: Record<string, PageLinks> = {
  'christmas-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'dingbats-fonts', href: '/fonts/dingbats-fonts/' },
      { label: 'colorful-fonts', href: '/fonts/color-fonts/' },
      { label: 'cute-fonts', href: '/fonts/cute-fonts/' },
      { label: 'handwriting-fonts', href: '/fonts/handwriting-fonts/' },
      { label: 'pretty-fonts', href: '/fonts/pretty-fonts/' },
      { label: 'fancy-fonts', href: '/fonts/fancy-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'wedding-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'elegant-fonts', href: '/fonts/elegant-fonts/' },
      { label: 'pretty-fonts', href: '/fonts/pretty-fonts/' },
      { label: 'handwriting-fonts', href: '/fonts/handwriting-fonts/' },
      { label: 'fancy-fonts', href: '/fonts/fancy-fonts/' },
      { label: 'heart-fonts', href: '/fonts/heart-fonts/' },
      { label: 'cute-fonts', href: '/fonts/cute-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'halloween-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'spooky-fonts', href: '/fonts/spooky-fonts/' },
      { label: 'death-metal-fonts', href: '/fonts/death-metal-fonts/' },
      { label: 'medieval-fonts', href: '/fonts/medieval-fonts/' },
      { label: 'pirate-fonts', href: '/fonts/pirate-fonts/' },
      { label: 'vintage-fonts', href: '/fonts/vintage-fonts/' },
    ],
    exploreMore: [
      { label: 'free-fonts', href: '/freebies/fonts/' },
      { label: 'scary-fonts-generator', href: '/tools/scary-text-generator/' },
    ],
  },
  'tattoo-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'chicano-fonts', href: '/fonts/chicano-fonts/' },
      { label: 'medieval-fonts', href: '/fonts/medieval-fonts/' },
      { label: 'death-metal-fonts', href: '/fonts/death-metal-fonts/' },
      { label: 'typewriter-fonts', href: '/fonts/typewriter-fonts/' },
      { label: 'bold-fonts', href: '/fonts/bold-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'cricut-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
    ],
    bottom: [
      { label: 'dingbats-fonts', href: '/fonts/dingbats-fonts/' },
      { label: 'cute-fonts', href: '/fonts/cute-fonts/' },
      { label: 'handwriting-fonts', href: '/fonts/handwriting-fonts/' },
      { label: 'heart-fonts', href: '/fonts/heart-fonts/' },
      { label: 'bubble-fonts', href: '/fonts/bubble-fonts/' },
      { label: 'fancy-fonts', href: '/fonts/fancy-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'retro-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: '70s-fonts', href: '/fonts/70s-fonts/' },
      { label: '80s-fonts', href: '/fonts/80s-fonts/' },
      { label: 'groovy-fonts', href: '/fonts/groovy-fonts/' },
      { label: 'vintage-fonts', href: '/fonts/vintage-fonts/' },
      { label: 'pixel-fonts', href: '/fonts/pixel-fonts/' },
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
      { label: 'comic-fonts', href: '/fonts/comic-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'calligraphy-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'signature-fonts', href: '/fonts/signature-fonts/' },
      { label: 'elegant-fonts', href: '/fonts/elegant-fonts/' },
      { label: 'fancy-fonts', href: '/fonts/fancy-fonts/' },
      { label: 'pretty-fonts', href: '/fonts/pretty-fonts/' },
      { label: 'handwriting-fonts', href: '/fonts/handwriting-fonts/' },
    ],
    exploreMore: [
      { label: 'free-fonts', href: '/freebies/fonts/' },
      { label: 'calligraphy-fonts-generator', href: '/tools/calligraphy-font-generator/' },
    ],
  },
  'cursive-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'signature-fonts', href: '/fonts/signature-fonts/' },
      { label: 'handwriting-fonts', href: '/fonts/handwriting-fonts/' },
      { label: 'elegant-fonts', href: '/fonts/elegant-fonts/' },
      { label: 'fancy-fonts', href: '/fonts/fancy-fonts/' },
      { label: 'pretty-fonts', href: '/fonts/pretty-fonts/' },
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
    ],
    exploreMore: [
      { label: 'free-fonts', href: '/freebies/fonts/' },
      { label: 'cursive-fonts-generator', href: '/tools/cursive-font-generator/' },
    ],
  },
  'graffiti-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'chicano-fonts', href: '/fonts/chicano-fonts/' },
      { label: 'comic-fonts', href: '/fonts/comic-fonts/' },
      { label: 'bold-fonts', href: '/fonts/bold-fonts/' },
      { label: 'block-fonts', href: '/fonts/block-fonts/' },
      { label: 'cool-fonts', href: '/fonts/cool-fonts/' },
      { label: 'stencil-fonts', href: '/fonts/stencil-fonts/' },
      { label: 'death-metal-fonts', href: '/fonts/death-metal-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'handwriting-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'signature-fonts', href: '/fonts/signature-fonts/' },
      { label: 'elegant-fonts', href: '/fonts/elegant-fonts/' },
      { label: 'pretty-fonts', href: '/fonts/pretty-fonts/' },
      { label: 'cute-fonts', href: '/fonts/cute-fonts/' },
      { label: 'fancy-fonts', href: '/fonts/fancy-fonts/' },
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'heart-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'cute-fonts', href: '/fonts/cute-fonts/' },
      { label: 'pretty-fonts', href: '/fonts/pretty-fonts/' },
      { label: 'fancy-fonts', href: '/fonts/fancy-fonts/' },
      { label: 'elegant-fonts', href: '/fonts/elegant-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'bubble-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'cute-fonts', href: '/fonts/cute-fonts/' },
      { label: 'colorful-fonts', href: '/fonts/color-fonts/' },
      { label: 'comic-fonts', href: '/fonts/comic-fonts/' },
      { label: 'aesthetic-fonts', href: '/fonts/aesthetic-fonts/' },
      { label: '80s-fonts', href: '/fonts/80s-fonts/' },
      { label: '70s-fonts', href: '/fonts/70s-fonts/' },
    ],
    exploreMore: [
      { label: 'free-fonts', href: '/freebies/fonts/' },
      { label: 'bubble-fonts-generator', href: '/tools/bubble-words-generator/' },
    ],
  },
  'typewriter-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'slab-serif-fonts', href: '/fonts/slab-serif-fonts/' },
      { label: 'vintage-fonts', href: '/fonts/vintage-fonts/' },
      { label: 'western-fonts', href: '/fonts/western-fonts/' },
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
      { label: 'bold-fonts', href: '/fonts/bold-fonts/' },
      { label: 'block-fonts', href: '/fonts/block-fonts/' },
    ],
    exploreMore: [
      { label: 'free-fonts', href: '/freebies/fonts/' },
      { label: 'typewriter-fonts-generator', href: '/tools/typewriter-font-generator/' },
    ],
  },
  'cute-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'bubble-fonts', href: '/fonts/bubble-fonts/' },
      { label: 'colorful-fonts', href: '/fonts/color-fonts/' },
      { label: 'pretty-fonts', href: '/fonts/pretty-fonts/' },
      { label: 'heart-fonts', href: '/fonts/heart-fonts/' },
      { label: 'fancy-fonts', href: '/fonts/fancy-fonts/' },
      { label: 'aesthetic-fonts', href: '/fonts/aesthetic-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'cool-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
      { label: 'bold-fonts', href: '/fonts/bold-fonts/' },
      { label: 'block-fonts', href: '/fonts/block-fonts/' },
      { label: 'space-fonts', href: '/fonts/space-fonts/' },
      { label: '80s-fonts', href: '/fonts/80s-fonts/' },
      { label: 'aesthetic-fonts', href: '/fonts/aesthetic-fonts/' },
    ],
    exploreMore: [
      { label: 'free-fonts', href: '/freebies/fonts/' },
      { label: 'cool-fonts-generator', href: '/tools/cool-fonts-generator/' },
    ],
  },
  'fancy-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'elegant-fonts', href: '/fonts/elegant-fonts/' },
      { label: 'pretty-fonts', href: '/fonts/pretty-fonts/' },
      { label: 'cute-fonts', href: '/fonts/cute-fonts/' },
      { label: 'handwriting-fonts', href: '/fonts/handwriting-fonts/' },
      { label: 'aesthetic-fonts', href: '/fonts/aesthetic-fonts/' },
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'aesthetic-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'fancy-fonts', href: '/fonts/fancy-fonts/' },
      { label: 'cute-fonts', href: '/fonts/cute-fonts/' },
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
      { label: 'pretty-fonts', href: '/fonts/pretty-fonts/' },
      { label: '70s-fonts', href: '/fonts/70s-fonts/' },
      { label: 'groovy-fonts', href: '/fonts/groovy-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'spooky-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'death-metal-fonts', href: '/fonts/death-metal-fonts/' },
      { label: 'medieval-fonts', href: '/fonts/medieval-fonts/' },
      { label: 'pirate-fonts', href: '/fonts/pirate-fonts/' },
      { label: 'vintage-fonts', href: '/fonts/vintage-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'pixel-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: '80s-fonts', href: '/fonts/80s-fonts/' },
      { label: '70s-fonts', href: '/fonts/70s-fonts/' },
      { label: 'space-fonts', href: '/fonts/space-fonts/' },
      { label: 'block-fonts', href: '/fonts/block-fonts/' },
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'western-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'slab-serif-fonts', href: '/fonts/slab-serif-fonts/' },
      { label: 'typewriter-fonts', href: '/fonts/typewriter-fonts/' },
      { label: 'vintage-fonts', href: '/fonts/vintage-fonts/' },
      { label: 'college-fonts', href: '/fonts/college-fonts/' },
      { label: 'bold-fonts', href: '/fonts/bold-fonts/' },
      { label: 'stencil-fonts', href: '/fonts/stencil-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'college-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'slab-serif-fonts', href: '/fonts/slab-serif-fonts/' },
      { label: 'bold-fonts', href: '/fonts/bold-fonts/' },
      { label: 'stencil-fonts', href: '/fonts/stencil-fonts/' },
      { label: 'baseball-fonts', href: '/fonts/baseball-fonts/' },
      { label: 'western-fonts', href: '/fonts/western-fonts/' },
      { label: 'block-fonts', href: '/fonts/block-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'groovy-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: '70s-fonts', href: '/fonts/70s-fonts/' },
      { label: '80s-fonts', href: '/fonts/80s-fonts/' },
      { label: 'vintage-fonts', href: '/fonts/vintage-fonts/' },
      { label: 'aesthetic-fonts', href: '/fonts/aesthetic-fonts/' },
      { label: 'colorful-fonts', href: '/fonts/color-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'signature-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'handwriting-fonts', href: '/fonts/handwriting-fonts/' },
      { label: 'elegant-fonts', href: '/fonts/elegant-fonts/' },
      { label: 'fancy-fonts', href: '/fonts/fancy-fonts/' },
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
      { label: 'pretty-fonts', href: '/fonts/pretty-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'bold-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'block-fonts', href: '/fonts/block-fonts/' },
      { label: 'stencil-fonts', href: '/fonts/stencil-fonts/' },
      { label: 'college-fonts', href: '/fonts/college-fonts/' },
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
      { label: 'typewriter-fonts', href: '/fonts/typewriter-fonts/' },
      { label: 'slab-serif-fonts', href: '/fonts/slab-serif-fonts/' },
    ],
    exploreMore: [
      { label: 'free-fonts', href: '/freebies/fonts/' },
      { label: 'bold-fonts-generator', href: '/tools/bold-text-generator/' },
    ],
  },
  'death-metal-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'medieval-fonts', href: '/fonts/medieval-fonts/' },
      { label: 'spooky-fonts', href: '/fonts/spooky-fonts/' },
      { label: 'pirate-fonts', href: '/fonts/pirate-fonts/' },
      { label: 'bold-fonts', href: '/fonts/bold-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'stencil-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'military-fonts', href: '/fonts/military-fonts/' },
      { label: 'bold-fonts', href: '/fonts/bold-fonts/' },
      { label: 'block-fonts', href: '/fonts/block-fonts/' },
      { label: 'college-fonts', href: '/fonts/college-fonts/' },
      { label: 'western-fonts', href: '/fonts/western-fonts/' },
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'baseball-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'college-fonts', href: '/fonts/college-fonts/' },
      { label: 'vintage-fonts', href: '/fonts/vintage-fonts/' },
      { label: 'bold-fonts', href: '/fonts/bold-fonts/' },
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
      { label: 'slab-serif-fonts', href: '/fonts/slab-serif-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'vintage-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: '70s-fonts', href: '/fonts/70s-fonts/' },
      { label: 'typewriter-fonts', href: '/fonts/typewriter-fonts/' },
      { label: 'slab-serif-fonts', href: '/fonts/slab-serif-fonts/' },
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
      { label: 'western-fonts', href: '/fonts/western-fonts/' },
      { label: '80s-fonts', href: '/fonts/80s-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'modern-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'aesthetic-fonts', href: '/fonts/aesthetic-fonts/' },
      { label: 'bold-fonts', href: '/fonts/bold-fonts/' },
      { label: 'elegant-fonts', href: '/fonts/elegant-fonts/' },
      { label: 'fancy-fonts', href: '/fonts/fancy-fonts/' },
      { label: 'cool-fonts', href: '/fonts/cool-fonts/' },
      { label: 'pretty-fonts', href: '/fonts/pretty-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'pretty-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'cute-fonts', href: '/fonts/cute-fonts/' },
      { label: 'elegant-fonts', href: '/fonts/elegant-fonts/' },
      { label: 'fancy-fonts', href: '/fonts/fancy-fonts/' },
      { label: 'heart-fonts', href: '/fonts/heart-fonts/' },
      { label: 'handwriting-fonts', href: '/fonts/handwriting-fonts/' },
      { label: 'aesthetic-fonts', href: '/fonts/aesthetic-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'medieval-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'death-metal-fonts', href: '/fonts/death-metal-fonts/' },
      { label: 'pirate-fonts', href: '/fonts/pirate-fonts/' },
      { label: 'spooky-fonts', href: '/fonts/spooky-fonts/' },
      { label: 'vintage-fonts', href: '/fonts/vintage-fonts/' },
      { label: 'bold-fonts', href: '/fonts/bold-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  '70s-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'groovy-fonts', href: '/fonts/groovy-fonts/' },
      { label: 'vintage-fonts', href: '/fonts/vintage-fonts/' },
      { label: 'colorful-fonts', href: '/fonts/color-fonts/' },
      { label: '80s-fonts', href: '/fonts/80s-fonts/' },
      { label: 'aesthetic-fonts', href: '/fonts/aesthetic-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'military-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'stencil-fonts', href: '/fonts/stencil-fonts/' },
      { label: 'bold-fonts', href: '/fonts/bold-fonts/' },
      { label: 'block-fonts', href: '/fonts/block-fonts/' },
      { label: 'western-fonts', href: '/fonts/western-fonts/' },
      { label: 'typewriter-fonts', href: '/fonts/typewriter-fonts/' },
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'space-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'pixel-fonts', href: '/fonts/pixel-fonts/' },
      { label: '80s-fonts', href: '/fonts/80s-fonts/' },
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
      { label: 'cool-fonts', href: '/fonts/cool-fonts/' },
      { label: 'aesthetic-fonts', href: '/fonts/aesthetic-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  '80s-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: '70s-fonts', href: '/fonts/70s-fonts/' },
      { label: 'vintage-fonts', href: '/fonts/vintage-fonts/' },
      { label: 'pixel-fonts', href: '/fonts/pixel-fonts/' },
      { label: 'space-fonts', href: '/fonts/space-fonts/' },
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
      { label: 'bold-fonts', href: '/fonts/bold-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'pirate-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'medieval-fonts', href: '/fonts/medieval-fonts/' },
      { label: 'death-metal-fonts', href: '/fonts/death-metal-fonts/' },
      { label: 'vintage-fonts', href: '/fonts/vintage-fonts/' },
      { label: 'spooky-fonts', href: '/fonts/spooky-fonts/' },
      { label: 'bold-fonts', href: '/fonts/bold-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'comic-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'chicano-fonts', href: '/fonts/chicano-fonts/' },
      { label: 'bubble-fonts', href: '/fonts/bubble-fonts/' },
      { label: 'cute-fonts', href: '/fonts/cute-fonts/' },
      { label: '80s-fonts', href: '/fonts/80s-fonts/' },
      { label: 'colorful-fonts', href: '/fonts/color-fonts/' },
      { label: 'block-fonts', href: '/fonts/block-fonts/' },
      { label: 'manga-fonts', href: '/fonts/manga-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'block-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'bold-fonts', href: '/fonts/bold-fonts/' },
      { label: 'stencil-fonts', href: '/fonts/stencil-fonts/' },
      { label: 'college-fonts', href: '/fonts/college-fonts/' },
      { label: 'military-fonts', href: '/fonts/military-fonts/' },
      { label: 'typewriter-fonts', href: '/fonts/typewriter-fonts/' },
      { label: 'slab-serif-fonts', href: '/fonts/slab-serif-fonts/' },
    ],
    exploreMore: [
      { label: 'free-fonts', href: '/freebies/fonts/' },
      { label: 'block-fonts-generator', href: '/tools/block-font-generator/' },
    ],
  },
  'chicano-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'death-metal-fonts', href: '/fonts/death-metal-fonts/' },
      { label: 'medieval-fonts', href: '/fonts/medieval-fonts/' },
      { label: 'signature-fonts', href: '/fonts/signature-fonts/' },
      { label: 'handwriting-fonts', href: '/fonts/handwriting-fonts/' },
      { label: 'vintage-fonts', href: '/fonts/vintage-fonts/' },
      { label: 'bold-fonts', href: '/fonts/bold-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'manga-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'comic-fonts', href: '/fonts/comic-fonts/' },
      { label: 'cute-fonts', href: '/fonts/cute-fonts/' },
      { label: 'bold-fonts', href: '/fonts/bold-fonts/' },
      { label: 'aesthetic-fonts', href: '/fonts/aesthetic-fonts/' },
      { label: '80s-fonts', href: '/fonts/80s-fonts/' },
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
  'elegant-fonts': {
    top: [
      { label: 'script-fonts', href: '/fonts/script-fonts/' },
      { label: 'serif-fonts', href: '/fonts/serif-fonts/' },
      { label: 'sans-serif-fonts', href: '/fonts/sans-serif-fonts/' },
      { label: 'display-fonts', href: '/fonts/display-fonts/' },
      { label: 'decorative-fonts', href: '/fonts/decorative-fonts/' },
      { label: 'blackletter-fonts', href: '/fonts/blackletter-fonts/' },
      { label: 'cursive-fonts', href: '/fonts/cursive-fonts/' },
      { label: 'tattoo-fonts', href: '/fonts/tattoo-fonts/' },
      { label: 'calligraphy-fonts', href: '/fonts/calligraphy-fonts/' },
      { label: 'retro-fonts', href: '/fonts/retro-fonts/' },
      { label: 'christmas-fonts', href: '/fonts/christmas-fonts/' },
      { label: 'graffiti-fonts', href: '/fonts/graffiti-fonts/' },
      { label: 'halloween-fonts', href: '/fonts/halloween-fonts/' },
      { label: 'wedding-fonts', href: '/fonts/wedding-fonts/' },
      { label: 'cricut-fonts', href: '/fonts/cricut-fonts/' },
    ],
    bottom: [
      { label: 'fancy-fonts', href: '/fonts/fancy-fonts/' },
      { label: 'pretty-fonts', href: '/fonts/pretty-fonts/' },
      { label: 'modern-fonts', href: '/fonts/modern-fonts/' },
      { label: 'handwriting-fonts', href: '/fonts/handwriting-fonts/' },
      { label: 'signature-fonts', href: '/fonts/signature-fonts/' },
    ],
    exploreMore: [{ label: 'free-fonts', href: '/freebies/fonts/' }],
  },
} as const
